import { configure, defineRule, Form, Field, ErrorMessage } from 'vee-validate'
import { localize, setLocale } from '@vee-validate/i18n'
import ja from '@vee-validate/i18n/dist/locale/ja.json'
import { all } from '@vee-validate/rules'

export default defineNuxtPlugin((nuxtApp) => {
  const { required, min_value, max_value, ...otherRules } = all

  Object.keys(otherRules).forEach((rule) => {
    defineRule(rule, all[rule])
  })

  // カスタムルールがある場合はここで defineRule

  defineRule('required', (value, _, ctx) => {
    return required(value) ? true : `${ctx.field}は必須です`
  })

  defineRule('min_value', (value: string, target: string[], ctx) => {
    return min_value(value, target)
      ? true
      : `${ctx.field}は${target[0]}以上にしてください`
  })

  defineRule('max_value', (value: string, target: string[], ctx) => {
    return max_value(value, target)
      ? true
      : `${ctx.field}は${target[0]}以下にしてください`
  })

  defineRule('required_non_zero', (value: string, _: any, { label }) => {
    return !['', null, undefined, 0, '0'].includes(value)
      ? true
      : `${label}は必須事項です`
  })

  defineRule('postal-code', (value: string) => {
    return /^\d{3}\d{4}$/.test(value)
      ? true
      : `正しい形式の郵便番号を入力してください`
  })

  defineRule('not_contain', (value: string, [target]: string[]) => {
    return !value.includes(target) ? true : `${target}が残っています`
  })

  defineRule('password', (value: string) => {
    return /[A-Za-z]/.test(value) && /\d/.test(value)
      ? true
      : `半角英数字の両方を含めて入力してください`
  })

  defineRule('confirmed', (value: string, [target]: string[], ctx) => {
    return value === ctx.form[target] ? true : `入力内容が一致しません`
  })

  defineRule('required_if_not', (value: string, [target]: string[], ctx) => {
    return !!ctx.form[target] || !!value
      ? true
      : `どちらかを入力する必要があります`
  })

  // 電話番号形式（数字、+、-のみ）かどうかをチェックする
  defineRule('phone', (value: string) => {
    if (!value) {
      return true
    }
    const phoneRegex = /^(?=.*\d)[0-9+-]+$/
    return phoneRegex.test(value)
      ? true
      : '電話番号を入力してください(数字、+、- 使用可)'
  })

  defineRule('gte', (value: string, [target]: string[], ctx) => {
    if (!value || !ctx.form[target]) {
      return true
    }

    const valueNum = Number(value)
    const targetNum = Number(ctx.form[target])
    if (isNaN(valueNum) || isNaN(targetNum)) {
      return true
    }

    return valueNum >= targetNum
      ? true
      : `${ctx.field}は${ctx.form[target]}以上で入力してください`
  })

  nuxtApp.vueApp.component('ValidationForm', Form)
  nuxtApp.vueApp.component('ValidationField', Field)
  nuxtApp.vueApp.component('ValidationErrorMessage', ErrorMessage)
  configure({
    generateMessage: localize({ ja }),
  })
  setLocale('ja')
})
